import { render, staticRenderFns } from "./mutilFile.vue?vue&type=template&id=3d60871c&scoped=true&"
import script from "./mutilFile.vue?vue&type=script&lang=js&"
export * from "./mutilFile.vue?vue&type=script&lang=js&"
import style0 from "./mutilFile.vue?vue&type=style&index=0&id=3d60871c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d60871c",
  null
  
)

export default component.exports